/* PRODUCTS */


export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST"
export const GET_PRODUCT_LIST_SUCCESS = "GET_PRODUCT_LIST_SUCCESS"
export const GET_PRODUCT_LIST_FAIL = "GET_PRODUCT_LIST_FAIL"



